import { Route, Routes } from 'react-router-dom';

// basic routes
import EditCheckout from '../components/Checkout/EditCheckout';

const Checkout = () => {
  return (
    <Routes>
      <Route path="/edit/:id" element={<EditCheckout />} />
      <Route path="/edit" element={<EditCheckout />} />
    </Routes>
  )
}

export default Checkout;